export default __webpack_public_path__ + "af653d8789c31057318815ff4b5bdc33.png";